import { combineReducers } from 'redux';
import undoable, { includeAction, excludeAction } from 'redux-undo';
import * as elementActionTypes from './element/actions/index';
import reduceReducers from 'reduce-reducers';
import { LOCATION_CHANGE, routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import editor from './editor/editor';
import template from './template/template';
import element from './element/element';
import user from './user/user';
import listingData from './listingData/listingData';
import colorPicker from './colorPicker/colorPicker';
import publishDialog from './publishDialog/publishDialog';
import panel from './panel/panel';
import stage from './stage/stage';
import trialExpired from './trialExpired/trialExpired';
import globalState from './globalState/globalState';
import RealTimeDBReducer from 'shared/realTimeDB/RealTimeDBReducer';
import accountPage from 'MyAccount/ViewDesigns/redux/modules/accountPage';

// this is a patch until a real fix will be implemented, check ticket CL-1546 to see what should be done
function undoablePatch(state, action) {
  let undoableElement = undoable(element, {
    limit: 100,
    filter: excludeAction([
      elementActionTypes.UPDATE_ELEMENT_POSITION,
      elementActionTypes.SET_ELEMENT_UPDATE_PREVIEW,
      elementActionTypes.CLEAR_ELEMENT_UPDATE_PREVIEW,
      elementActionTypes.UPDATE_MEASURED_HEIGHTS,
      elementActionTypes.ADD_MOBILE_ELEMENTS_FIRST_STEP,
      elementActionTypes.ADD_MOBILE_ELEMENTS_SECOND_STEP,
      elementActionTypes.ADD_MOBILE_ELEMENTS_THIRD_STEP,
      elementActionTypes.RESIZE_MOBILE_ELEMENTS,
      LOCATION_CHANGE
    ]),
    undoType: elementActionTypes.UNDO_ACTION_ELEMENT,
    redoType: elementActionTypes.REDO_ACTION_ELEMENT
  })(state, action);
  if (undoableElement.wasFiltered) {
    undoableElement = {...state, present: undoableElement.present};
  }
  return undoableElement;
}

export default function() {
  return reduceReducers(
    combineReducers({
      routing: routerReducer,
      editor,
      template,
      element: undoablePatch,
      user,
      colorPicker,
      publishDialog,
      panel,
      stage,
      trialExpired,
      templateTagSet: state => (state || {}),
      general: state => (state || {}),
      listingData,
      accountPage,
      form: formReducer
    }),
    globalState,
    RealTimeDBReducer,
  );
}

